import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return undefined;
  }

  if (profile.likesNotification) {
    return profile.likesNotification;
  } else {
    return undefined;
  }
};
//VERIFY IF THE JWT IS SET
const getMyLikesNotificationCount = createSelector(getData, count => count);
export default getMyLikesNotificationCount;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyLikesNotificationCount.js